'use client';
import React, { useState } from 'react';
import { LESSONS } from '@/lib/mockData';
import LessonCard from '@/components/ui/LessonCard';

import TeacherToolsSidebar from './TeacherToolsSidebar';
import LessonOverviewTab from './LessonOverviewTab';
import LessonPlanTab from './LessonPlanTab';
import ActivitiesTab from './ActivitiesTab';
import AssessmentTab from './AssessmentTab';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'plan', label: 'Lesson Plan' },
  { id: 'activities', label: 'Activities' },
  { id: 'assessment', label: 'Assessment' },
];

export default function LessonDetailBody() {
  const [activeTab, setActiveTab] = useState('overview');
  const lesson = LESSONS?.[3];
  const related = LESSONS?.filter((l) => l?.id !== lesson?.id && l?.topic === lesson?.topic)?.slice(0, 3);

  return (
    <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-8">
      <div className="flex flex-col lg:flex-row gap-8 items-start">
        {/* Main content */}
        <div className="flex-1 min-w-0">
          {/* Tabs */}
          <div className="flex items-center gap-1 border-b border-stone-200 mb-8 overflow-x-auto scrollbar-hide">
            {TABS?.map((tab) => (
              <button
                key={`tab-${tab?.id}`}
                onClick={() => setActiveTab(tab?.id)}
                className={`px-4 py-3 text-sm font-medium whitespace-nowrap transition-all duration-150 border-b-2 -mb-px ${
                  activeTab === tab?.id
                    ? 'border-primary-500 text-primary-600' :'border-transparent text-stone-500 hover:text-stone-700'
                }`}
              >
                {tab?.label}
              </button>
            ))}
          </div>

          {/* Tab content */}
          <div className="animate-fade-in">
            {activeTab === 'overview' && <LessonOverviewTab lesson={lesson} />}
            {activeTab === 'plan' && <LessonPlanTab lesson={lesson} />}
            {activeTab === 'activities' && <ActivitiesTab />}
            {activeTab === 'assessment' && <AssessmentTab />}
          </div>

          {/* Related lessons */}
          <div className="mt-14">
            <h2 className="font-display text-2xl font-bold text-stone-800 mb-6">
              Related Lessons
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
              {related?.map((l) => (
                <LessonCard key={l?.id} lesson={l} />
              ))}
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <aside className="w-full lg:w-72 xl:w-80 flex-shrink-0 lg:sticky lg:top-20">
          <TeacherToolsSidebar lesson={lesson} />
        </aside>
      </div>
    </div>
  );
}